import { reduce } from "et3-type-guards";

import configuration from "../../configuration/keys/index";
import i18n from "../../constants/i18n";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCorePersonalStore from "../../stores/core/core-personal-store";
import getCoreUIStore from "../../stores/core/core-ui-store";
import ProfileDropdownButtons from "./ProfileDropdownButtons";
import ET3Div from "../../core/et3-div";
import Et3Text from "../../core/et3-text";
import Et3Margin from "../../core/et3-ui/ET3Margin";

const Textinfo = withLiteObserverAndTheme<{
  title: string;
  subTitle: string;
}>((props) => {
  const { theme, title, subTitle } = props;
  const { colors } = theme;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="center"
      withShadow={false}
      width={360}
      height={50}
      color={colors.all.white}
      style={{}}
      onClick={() => {}}
    >
      <Et3Text
        fontFamily={"BOLD"}
        fontSize={18}
        text={`${title}:`}
        isSpan={false}
        color={colors.all.bondiBlue}
        style={{}}
      />
      <Et3Margin left={5} right={5} top={0} bottom={0} />
      <Et3Text
        fontFamily={"LIGHT"}
        fontSize={18}
        text={`${subTitle}`}
        isSpan={false}
        color={colors.all.bondiBlue}
        style={{}}
      />
    </ET3Div>
  );
});
const ProfileDropdown = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors, unitX, unitY } = theme;
  const user = getCorePersonalStore().user.get();
  const name = reduce(() => user.fullName, "Full Name");
  const role = reduce(() => user.role, "");
  const lastLogin = reduce(() => user.lastLogin, "Last login");

  return getCoreUIStore().isProfileDropdownVisible.get() ? (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="center"
      alignItems="center"
      withShadow={true}
      width={390}
      height={450}
      color={colors.all.white}
      style={{
        display: "flex",
        position: "absolute",
        right: 40 * unitX,
        top: 120 * unitY,
        zIndex: 101,
        borderRadius: 30 * unitX
      }}
      onClick={() => {}}
    >
      <ET3Div
        isScrollable={false}
        isExtendable={false}
        fDirection="column"
        justifyContent="space-around"
        alignItems="flex-start"
        withShadow={false}
        width={360}
        height={420}
        color={colors.all.transparent}
        style={{}}
        onClick={() => {}}
      >
        <Textinfo title={name} subTitle={role} />
        <Textinfo title={i18n.get("LAST_LOGIN")} subTitle={lastLogin} />
        <Textinfo title={i18n.get("DEPLOYED")} subTitle={configuration.date} />
        <Textinfo
          title={i18n.get("ENVIRONMENT")}
          subTitle={configuration.env}
        />
        <Textinfo
          title={i18n.get("VERSION")}
          subTitle={configuration.version}
        />
        <ProfileDropdownButtons />
      </ET3Div>
    </ET3Div>
  ) : null;
});
export default ProfileDropdown;
